import * as http from './http';
import ApiService from './service';
import { Timings } from '../../models/date';
import { ScheduleResourceEnum } from '../../models/schedule';

const serviceEndpoint = 'entity/v1';

export default class EntityService extends ApiService {
  public async getAppointmentSlots(date: Date) {
    const url = `${this.apiDomain}/${serviceEndpoint}/appointment-slotes?date=${date}`;
    return http.get(url, this.token);
  }
  public async getMockTestOtpSettings() {
    const url = `${this.apiDomain}/${serviceEndpoint}/app-settings/mocktest-sms-settings`;
    return http.get(url, this.token);
  }
  public async getAppSettingsByKey(key: string, overrideToken?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/app-settings?key=${key}`;
    return http.get(url, overrideToken || this.token);
  }
}
